"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTextInputElement = exports.renderTextInputItem = exports.BmTextInputField = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _inputFieldRenderer = require("../../../../core/render/items/input-engine/input-field-renderer");

var _fieldRenderer = require("../../../../core/render/items/input-engine/field-renderer");

var _maskedTextInput = require("../../../../core/render/items/input-engine/inputs/masked-text-input");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-text-input-field .info=\"", "\"></bm-text-input-field> "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<style>\n\t\t\t\tbm-masked-text-input {\n\t\t\t\t\t--bm-masked-input-bold: bold;\n\t\t\t\t}\n\t\t\t</style>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\n\t\t\t<bm-masked-text-input\n\t\t\t\t.name=\"", "\"\n\t\t\t\t.disabled=\"", "\"\n\t\t\t\t.readonly=\"", "\"\n\t\t\t\t.required=\"", "\"\n\t\t\t\t.touched=\"", "\"\n\t\t\t\t.dirty=\"", "\"\n\t\t\t\t.value=\"", "\"\n\t\t\t\t.mask=\"", "\"\n\t\t\t\t.dataQeId=\"", "\"\n\t\t\t\t@bm-form-event=\"", "\"\n\t\t\t></bm-masked-text-input>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmTextInputField = /*#__PURE__*/function (_BmInputFieldElement) {
  (0, _inherits2.default)(BmTextInputField, _BmInputFieldElement);

  var _super = (0, _createSuper2.default)(BmTextInputField);

  function BmTextInputField() {
    (0, _classCallCheck2.default)(this, BmTextInputField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmTextInputField, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changed) {
      if (!this.info) return false;
      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmTextInputField.prototype), "shouldUpdate", this).call(this, changed);
    }
  }, {
    key: "_renderInput",
    value: function _renderInput() {
      var _this$info$options$ma;

      return this.html(_templateObject(), this._setCustomProps(), this.info.name, Boolean(this.info.disabled), this.readonly, Boolean(this.required), Boolean(this.info.touched), Boolean(this.info.dirty), this.info.value, (_this$info$options$ma = this.info.options.mask) === null || _this$info$options$ma === void 0 ? void 0 : _this$info$options$ma.options, this.info.options.dataQeId, this.handleFormEvent);
    }
  }, {
    key: "handleFormEvent",
    value: function handleFormEvent(evt) {
      if (evt.detail.type === 'changed') {
        var nextValue = evt.detail.data.currentValue || null;
        evt.detail.data.currentValue = nextValue;
      }
    }
  }, {
    key: "_setCustomProps",
    value: function _setCustomProps() {
      return this.info.options.styles === 'bold' ? this.html(_templateObject2()) : null;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-text-input-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);
  return BmTextInputField;
}(_inputFieldRenderer.BmInputFieldElement);

exports.BmTextInputField = BmTextInputField;

var renderTextInputItem = function renderTextInputItem(info) {
  return (0, _element.html)(_templateObject3(), info);
};

exports.renderTextInputItem = renderTextInputItem;

var registerTextInputElement = function registerTextInputElement() {
  (0, _element.register)(_fieldRenderer.BmField);
  (0, _maskedTextInput.registerBmMaskedTextInput)();
  (0, _element.register)(BmTextInputField);
};

exports.registerTextInputElement = registerTextInputElement;
